
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind as ObiWindElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind.js';
 
 
 

 
 export const ObiWind = createComponent({
   react: React,
   tagName: 'obi-wind',
   elementClass: ObiWindElement,
   events: {
     
   }
  });
 
 